import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.5 4.75c0-.69-.56-1.25-1.25-1.25H2.75c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25zm1.5 8.5A2.75 2.75 0 0 1 13.25 16H2.75A2.75 2.75 0 0 1 0 13.25v-8.5A2.75 2.75 0 0 1 2.75 2h10.5A2.75 2.75 0 0 1 16 4.75z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.25 4.25V.75a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0m8 0V.75a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0m1 1.75a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }